/**
 * Licensed Materials - Property of IBM
 *
 * "Restricted Materials of IBM"
 *
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Checkbox } from '@ba/ba-ui-carbon-toolkit';
import PropTypes from 'util/PropTypes';
import StringResources from 'nls/StringResources';
import { REJECTED } from 'mobx-utils';
import './editDiagram.scss';

@observer
class EditDiagramMenu  extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		return (
			this._buildMenuItems()
		);
	}

	componentDidMount() {
		if (this.props.onClose) {
			document.addEventListener('mousedown', this._onClose.bind(this));
			document.addEventListener('touchstart', this._onClose.bind(this));
		}
	}

	componentWillUnmount() {
		if (this.props.onClose) {
			document.removeEventListener('mousedown', this._onClose.bind(this));
			document.removeEventListener('touchstart', this._onClose.bind(this));
		}
	}

	_onClose(event) {
		if (this._dropdown && !this._dropdown.contains(event.target) && this.props.triggerNode && !this.props.triggerNode.contains(event.target)) {
			this.props.onClose();
		}
	}

	_buildMenuItems() {
		const state = this.props.dataState;
		const contents = [];
		if (this.props.isEditScopeFeatureEnabled){
			contents.push(
				<div className="edit-diagram-menu__changeScope" tabIndex={0} aria-label={StringResources.get('change_scope')}
					onClick={this._onChangeScopeClick.bind(this)}
					onKeyDown={this._onKeyDown.bind(this)}>
					<span>{StringResources.get('change_scope')}</span>
				</div>
			);
		}
		if (state !== REJECTED) {
			contents.push(this._buildCheckboxMarkUp());
		}
		return (
			<div className="edit-diagram-menu"
				ref={node => this._dropdown = node}
			>
				{contents}
			</div>
		);
	}

	_onKeyDown(event) {
		switch (event.key) {
			case ' ': // space
			case 'Enter':
				this._onChangeScopeClick();
				break;
		}
	}

	_onChangeScopeClick() {
		this.props.onChangeScopeClick();
		// Close dropdown after opening "Edit scope" dialog
		this.props.onClose();
	}

	_buildCheckboxMarkUp() {
		const label = StringResources.get('relationshipGraph_secondaryRelationship_label');
		const alignment = 'left';
		return (
			<Checkbox
				className = "edit-diagram-menu__checkbox"
				label = {label}
				align = {alignment}
				onChange={() => {
					this.props.targetModel.setShowPrimaryRelationshipView(!this.props.targetModel.showPrimaryRelationshipView);
				}}
				checked={!this.props.targetModel.showPrimaryRelationshipView}
				size='small'
			/>
		);
	}

}

EditDiagramMenu.propTypes = {
	triggerNode: PropTypes.node,
	targetModel: PropTypes.object.isRequired,
	onClose: PropTypes.func,
	onChangeScopeClick: PropTypes.func,
	isEditScopeFeatureEnabled: PropTypes.bool,
	dataState: PropTypes.object.isRequired
};


export default EditDiagramMenu ;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/EditDiagramMenu.js